import React from 'react';
import Paper from '@mui/material/Paper';
import RebookFlightTrack from '../RebookFlightTrack';
import FlightDetails from './FlightDetails';
import { useStyles } from './use-styles';
import * as TFF from '@tff/types/tff';

interface Props {
  orderDetails: TFF.OrderDetails;
  journey: TFF.Journey;
  airports: TFF.Airport[];
  displayFlights?: boolean;
  displayConfirmation?: boolean;
  retrieveDb?: TFF.Retrieve;
  setEnableSearchAlternatives: (value: boolean) => void;
}

const ChangeFlightCard: React.FC<Props> = ({
  journey,
  airports,
  orderDetails,
  displayFlights,
  displayConfirmation,
  retrieveDb,
}) => {
  const classes = useStyles();

  return (
    <Paper
      style={{ display: !displayFlights && !displayConfirmation ? 'block' : 'none' }}
      elevation={2}
      className={classes.root}
    >
      {journey && airports && <RebookFlightTrack journey={journey} airports={airports} orderDetails={orderDetails} />}
      <FlightDetails
        orderDetails={orderDetails}
        journey={journey}
        airports={airports}
        retrieveDb={retrieveDb}
      />
    </Paper>
  );
};

export default ChangeFlightCard;
